<template>
  <hr class="my-6 hr-grey" />
  <ion-text class="text-md font-bold ion-text-brand">Password</ion-text>
  <button
    expand="block"
    fill="outline"
    class="button-outline button-icon button-icon-security mt-6 mb-0"
    @click="nextStep"
    data-cy="security-details-button-pw"
  >
    <span class="block capitalize text-[14px] height-[60px]"
      >Change Your Password</span
    >
  </button>
</template>

<script setup>
import router from "@/router";
const nextStep = () => {
  router.push({ name: 'ChangePassword' });
};
</script>
